import React, {
  useMemo,
} from 'react';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Preview from 'Components/Modals/FileViewer/Preview';
import classnames from 'classnames';
import { imageTypes } from 'Consts/activityFeed';
import Paper from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Paper';
import PropTypes from 'prop-types';

const useStyles = makeStyles(() => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexWrap: 'wrap',
    height: '80vh',
    justifyContent: 'center',
  },
  paperRoot: {
    height: '100%',
    width: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    overflow: 'hidden',
    transition: 'all .2s ease',
    verticalAlign: 'middle',
  },
  paperRootAlignTop: {
    backgroundPosition: 'top',
  },
}));

const PreviewItem = ({
  attachmentName,
  attachmentHref,
  hasResource,
  height,
  width,
  alignItem,
  presentsAsDownloadable,
}) => {
  const classes = useStyles();

  const isImageAttachment = useMemo(() => {
    if (!hasResource) {
      return false;
    }
    return imageTypes.includes(attachmentName.split('.').pop().toLowerCase());
  }, [hasResource]);

  if (isImageAttachment) {
    return (<Paper
      className={classnames(
        classes.root,
      )}
      rounded={false}
      tabIndex={0}
      classes={{
        root: classnames(
          classes.paperRoot,
          {
            [classes.paperRootAlignTop]: alignItem === 'top',
          },
        ),
      }}
      role="button"
      style={{
        backgroundImage: `url('${attachmentHref}')`,
        height,
        width,
      }}
    />);
  }

  return (
    <Preview
      classes={classes}
      className={'attachmentPreview'}
      fileName={attachmentName}
      href={attachmentHref}
      presentsAsDownloadable={presentsAsDownloadable}
      iframeStyle={{
        border: 'none',
        height: height || '100%',
        width: width || '100%',
        display: 'flex',
        alignItems: alignItem === 'center' ? 'center' : 'top',
        alignContent: 'center',
        justifyItems: 'center',
      }}
    />
  );
};

PreviewItem.defaultProps = {
  hasResource: true,
  height: undefined,
  width: undefined,
  alignItem: 'center',
};

PreviewItem.propTypes = {
  attachmentName: PropTypes.string.isRequired,
  attachmentHref: PropTypes.string.isRequired,
  hasResource: PropTypes.bool,
  alignItem: PropTypes.oneOf(['top', 'center']),
  height: PropTypes.number,
  width: PropTypes.number,
  presentsAsDownloadable: PropTypes.bool,
};

export { PreviewItem };
